var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfetti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6713_127043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.5896 77.2064C73.2504 77.5444 72.8394 77.7995 72.36 77.9742L71.8763 78.1195C71.8763 78.1195 6.65 104.437 1.57823 99.3466C-3.49353 94.2562 23.061 29.1262 23.061 29.1262L23.208 28.643C23.3845 28.1642 23.6412 27.7542 23.9804 27.4162C28.0378 23.3734 42.4335 31.2413 56.1326 44.9903C69.8316 58.7393 77.6471 73.1638 73.5896 77.2064Z",
    fill: "url(#paint0_linear_6713_127043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5315 79.0545C66.0988 80.4157 59.2255 83.11 51.1094 86.1259C46.1455 87.9712 40.7162 89.9367 35.3251 91.7891C30.6139 93.4081 25.9309 94.9438 21.6158 96.2377C18.6511 93.7461 15.7049 91.0438 12.8184 88.1469C9.93192 85.25 7.24055 82.2938 4.75977 79.32C6.06937 75.0098 7.62212 70.3322 9.25839 65.6271C11.1304 60.2426 13.1156 54.8206 14.979 49.8636C18.0245 41.7585 20.7439 34.8951 22.1174 31.4673C30.8692 36.2132 40.2211 43.2318 49.027 52.0698C57.8331 60.9081 64.8176 70.2855 69.5315 79.0545Z",
    fill: "url(#paint1_linear_6713_127043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5892 77.2056C73.2507 77.5448 72.8388 77.7985 72.3596 77.9744L71.8764 78.1185C71.8764 78.1185 71.0331 78.4587 69.5315 79.0542C66.0988 80.4154 59.2254 83.1097 51.1094 86.1256C46.1454 87.9709 40.7162 89.9364 35.325 91.7887C30.6392 88.2546 25.9425 84.1719 21.3917 79.6044C16.8409 75.037 12.7754 70.3254 9.25818 65.6268C11.1301 60.2422 13.1154 54.8203 14.9788 49.8632C18.0243 41.7581 20.7437 34.8948 22.1172 31.467C22.7182 29.9675 23.0615 29.1256 23.0615 29.1256L23.2074 28.6428C23.3852 28.1642 23.6403 27.7532 23.9807 27.416C28.0384 23.373 42.4327 31.2415 56.1327 44.9893C69.8309 58.7397 77.6468 73.1626 73.5892 77.2056Z",
    fill: "url(#paint2_linear_6713_127043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5892 77.2056C73.2508 77.5449 72.8388 77.7986 72.3596 77.9745L71.8765 78.1186C71.8765 78.1186 71.0331 78.4588 69.5316 79.0543C66.0988 80.4154 59.2255 83.1098 51.1094 86.1256C44.5033 81.7751 37.7363 76.2617 31.2653 69.767C24.7943 63.2723 19.3055 56.4852 14.979 49.8635C18.0245 41.7584 20.7439 34.895 22.1174 31.4672C22.7184 29.9678 23.0617 29.1258 23.0617 29.1258L23.2076 28.6431C23.3855 28.1645 23.6406 27.7535 23.981 27.4162C28.0386 23.3733 42.4329 31.2417 56.1329 44.9896C69.831 58.7398 77.6469 73.1627 73.5892 77.2056Z",
    fill: "url(#paint3_linear_6713_127043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.589 77.2068C69.5307 81.2503 55.1352 73.3825 41.4362 59.6333C27.7372 45.884 19.9215 31.4603 23.9797 27.4166C28.038 23.3729 42.4335 31.2409 56.1325 44.9901C69.8315 58.7393 77.6472 73.1633 73.589 77.2068Z",
    fill: "url(#paint4_linear_6713_127043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0599 73.5006C68.0618 76.4878 55.9197 69.1623 43.9399 57.1388C31.9601 45.1153 24.6789 32.9466 27.6769 29.9594C30.675 26.9721 42.8171 34.2976 54.7969 46.3211C66.7767 58.3447 74.0581 70.5133 71.0599 73.5006Z",
    fill: "url(#paint5_linear_6713_127043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5896 77.2064C77.647 73.1636 69.8317 58.7395 56.1325 44.9905C48.0997 36.9285 39.8286 30.8903 33.5415 28.0881C33.787 28.5399 34.0609 28.9877 34.367 29.4293C34.8644 30.147 35.4468 30.8011 36.1025 31.3909L39.5811 34.8936C39.1801 35.0756 38.8117 35.2195 38.5019 35.3287C37.9472 35.5242 37.6225 36.0979 37.7386 36.6744L38.9695 42.7889C39.0784 43.3295 39.4576 43.7401 39.9315 43.9195L73.3284 77.4381C73.4195 77.366 73.5068 77.2889 73.5896 77.2064Z",
    fill: "url(#paint6_linear_6713_127043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3833 58.2089L54.7994 62.2926L70.7125 78.2638C71.9288 78.2295 72.906 77.8877 73.5892 77.207C77.1355 73.6734 71.6145 62.2134 61.0239 50.2036C57.7237 51.5818 54.5776 53.386 51.6723 55.6042C50.8515 56.2305 50.7207 57.4169 51.3833 58.2089Z",
    fill: "url(#paint7_linear_6713_127043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7994 62.2928L51.3833 58.2091C50.7208 57.4172 50.8515 56.2309 51.6721 55.6042C62.259 47.5215 76.0298 44.8962 88.8908 48.5952C92.1276 49.526 95.227 50.8313 98.1282 52.4836C99.0257 52.9948 99.3133 54.1538 98.7619 55.0272L95.92 59.5293C95.4047 60.3456 94.3417 60.6123 93.4998 60.1405C91.2729 58.893 88.8982 57.903 86.419 57.1901C76.3612 54.2973 65.5964 56.3158 57.279 62.5766C56.508 63.1568 55.4184 63.0328 54.7994 62.2928Z",
    fill: "url(#paint8_linear_6713_127043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.28 19.8964L22.1782 16.7048C20.7723 15.2582 20.349 12.9295 21.17 11.159C22.1231 9.10307 24.4105 8.50053 26.2529 9.81994C27.8398 10.9564 28.6186 13.1913 28.1078 15.1429L26.9811 19.4484C26.7821 20.2092 25.8282 20.4605 25.28 19.8964Z",
    fill: "url(#paint9_linear_6713_127043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7936 23.3623L15.3893 22.7223C13.393 22.4323 11.6381 20.844 11.2099 18.9399C10.7126 16.7289 12.1589 14.8572 14.4236 14.7805C16.3742 14.7144 18.3538 16.0115 19.1383 17.8701L20.8691 21.9703C21.1751 22.6948 20.5718 23.4754 19.7936 23.3623Z",
    fill: "url(#paint10_linear_6713_127043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7625 74.5586L83.1949 74.1575C85.2039 73.9757 87.2798 75.1124 88.1388 76.8649C89.1362 78.8996 88.1647 81.0563 85.9798 81.6575C84.0978 82.1751 81.8711 81.3735 80.676 79.7482L78.0398 76.1626C77.5741 75.5288 77.9792 74.6294 78.7625 74.5586Z",
    fill: "url(#paint11_linear_6713_127043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5229 68.1138L82.7926 65.0944C84.2745 63.7258 86.6131 63.362 88.3624 64.2277C90.3933 65.233 90.9375 67.535 89.5714 69.3432C88.3949 70.9007 86.1408 71.6222 84.2029 71.062L79.9275 69.826C79.1722 69.6075 78.9453 68.6473 79.5229 68.1138Z",
    fill: "url(#paint12_linear_6713_127043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9332 43.946C40.0659 44.2256 39.1495 43.6825 38.9697 42.7891L37.7387 36.6746C37.6226 36.0979 37.9473 35.5244 38.502 35.3289C39.1502 35.1005 40.051 34.7246 40.9822 34.1521C38.1699 33.2236 35.8814 31.6138 34.3673 29.4295C31.5128 25.3113 31.2891 20.6693 33.7685 17.0123C36.222 13.3934 40.7555 11.6279 45.0506 12.6195C49.7461 13.7034 53.0444 17.8119 53.8734 23.6099C53.9079 23.8513 53.9385 24.0915 53.965 24.3307C55.1169 23.6558 56.0477 22.8232 56.6306 21.8913C58.1063 19.5326 58.2463 16.0127 56.9879 12.9238C56.1891 10.9634 54.9559 9.46422 53.5652 8.7101C52.9448 8.37383 52.6142 7.67598 52.7804 6.9903L54.1906 1.1752C54.4067 0.284612 55.3553 -0.227937 56.2112 0.0999059C60.1581 1.61147 63.4055 4.97324 65.2701 9.54893C67.6132 15.2995 67.2081 21.8462 64.2126 26.6344C61.8426 30.4227 57.4716 33.2483 52.4175 34.4428C51.2822 36.8166 49.5832 38.9019 47.3548 40.6103C44.9752 42.4342 42.5099 43.4377 40.9332 43.946ZM42.6861 21.2944C42.1012 21.2934 41.4732 21.5846 41.1708 22.0309C40.7191 22.6972 41.3195 23.7605 41.7175 24.3348C42.2634 25.1225 43.5344 25.7101 45.1353 25.9732C45.1122 25.6168 45.0738 25.2511 45.0201 24.8758C44.7344 22.8781 43.9938 21.554 43.0389 21.3336C42.9253 21.3074 42.8067 21.2946 42.6861 21.2944Z",
    fill: "url(#paint13_radial_6713_127043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3755 30.764L53.9649 24.3301C53.9649 24.3301 54.3743 30.5426 52.4172 34.4424C55.3978 33.7381 58.1404 32.466 60.3755 30.764Z",
    fill: "url(#paint14_linear_6713_127043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7175 24.3348C41.4259 23.914 41.0275 23.2314 41.0118 22.6342L32.0565 22.6179C32.0704 24.8848 32.844 27.2316 34.3673 29.4295C35.8814 31.614 38.1697 33.2238 40.9822 34.152C40.9822 34.152 45.572 32.7597 45.1355 25.9732C43.5344 25.7101 42.2634 25.1224 41.7175 24.3348Z",
    fill: "url(#paint15_linear_6713_127043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7073 44.7017C58.6284 46.0564 56.8545 47.8409 55.5114 49.9284C55.2092 50.3978 54.5122 50.3966 54.2118 49.926C52.8761 47.8337 51.109 46.0427 49.0349 44.6803C48.5745 44.378 48.5759 43.6903 49.0373 43.3898C51.1161 42.0351 52.8898 40.2505 54.2331 38.1631C54.5351 37.6937 55.2324 37.6949 55.5328 38.1654C56.8684 40.2578 58.6357 42.0488 60.7096 43.4111C61.17 43.7135 61.1686 44.4011 60.7073 44.7017Z",
    fill: "url(#paint16_linear_6713_127043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7189 41.9683C96.64 43.323 94.8661 45.1075 93.523 47.195C93.221 47.6644 92.5238 47.6632 92.2234 47.1926C90.8877 45.1003 89.1206 43.3093 87.0465 41.9469C86.5861 41.6446 86.5875 40.957 87.0489 40.6564C89.1277 39.3017 90.9014 37.5171 92.2447 35.4297C92.5467 34.9603 93.244 34.9615 93.5444 35.432C94.88 37.5244 96.6473 39.3154 98.7212 40.6777C99.1816 40.9799 99.1802 41.6675 98.7189 41.9683Z",
    fill: "url(#paint17_linear_6713_127043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9176 11.6087C78.8388 12.9634 77.0649 14.7479 75.7217 16.8354C75.4196 17.3048 74.7225 17.3036 74.4221 16.833C73.0864 14.7407 71.3194 12.9497 69.2452 11.5873C68.7849 11.285 68.7862 10.5973 69.2476 10.2967C71.3264 8.94204 73.1001 7.15753 74.4435 5.07007C74.7454 4.60066 75.4427 4.60184 75.7431 5.07243C77.0788 7.16478 78.846 8.95576 80.9199 10.3181C81.3803 10.6205 81.379 11.3081 80.9176 11.6087Z",
    fill: "url(#paint18_linear_6713_127043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9912 32.5438C77.4757 33.5315 76.1827 34.8322 75.2035 36.3538C74.9833 36.696 74.4751 36.695 74.2563 36.3521C73.2827 34.8268 71.9945 33.5213 70.4825 32.5281C70.1471 32.3077 70.1478 31.8066 70.4843 31.5873C71.9998 30.5997 73.2927 29.2989 74.272 27.7773C74.4922 27.4352 75.0004 27.436 75.2192 27.7791C76.1929 29.3044 77.4812 30.6099 78.9929 31.603C79.3286 31.8234 79.3277 32.3246 78.9912 32.5438Z",
    fill: "url(#paint19_linear_6713_127043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1633 20.7814C83.6478 21.769 82.3549 23.0698 81.3756 24.5914C81.1555 24.9335 80.6472 24.9325 80.4284 24.5896C79.4549 23.0643 78.1666 21.7588 76.6547 20.7657C76.3192 20.5453 76.32 20.0441 76.6564 19.8249C78.1719 18.8372 79.4649 17.5365 80.4441 16.0149C80.6643 15.6727 81.1725 15.6735 81.3913 16.0167C82.3651 17.542 83.6533 18.8474 85.1651 19.8406C85.5006 20.061 85.4996 20.5621 85.1633 20.7814Z",
    fill: "url(#paint20_linear_6713_127043)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6713_127043",
    x1: 13.8211,
    y1: 48.9179,
    x2: 42.8458,
    y2: 90.6878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#FFDE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    stopColor: "#FFCA65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#FFAA87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF90A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6713_127043",
    x1: 36.4301,
    y1: 81.6632,
    x2: 30.8261,
    y2: 101.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBA5C2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3857,
    stopColor: "#FCA0BA",
    stopOpacity: 0.386
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9737,
    stopColor: "#FF91A5",
    stopOpacity: 0.974
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF90A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6713_127043",
    x1: 42.0599,
    y1: 69.8953,
    x2: 35.1205,
    y2: 94.7901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBA5C2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3857,
    stopColor: "#FCA0BA",
    stopOpacity: 0.386
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9737,
    stopColor: "#FF91A5",
    stopOpacity: 0.974
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF90A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6713_127043",
    x1: 46.668,
    y1: 56.3747,
    x2: 37.9994,
    y2: 84.7108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBA5C2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3857,
    stopColor: "#FCA0BA",
    stopOpacity: 0.386
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9737,
    stopColor: "#FF91A5",
    stopOpacity: 0.974
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF90A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6713_127043",
    x1: 51.5996,
    y1: 45.9686,
    x2: 42.4163,
    y2: 66.6193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#FFDE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    stopColor: "#FFCA65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#FFAA87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF90A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6713_127043",
    x1: 42.9385,
    y1: 61.5737,
    x2: 55.8962,
    y2: 41.7258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD00D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB722B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6713_127043",
    x1: 54.9425,
    y1: 52.8702,
    x2: 46.8439,
    y2: 28.0115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD00D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB722B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6713_127043",
    x1: 64.5678,
    y1: 66.5824,
    x2: 58.0309,
    y2: 55.8373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A34A9E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343168"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6713_127043",
    x1: 74.8591,
    y1: 63.2232,
    x2: 75.1571,
    y2: 46.8414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A34A9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343168"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6713_127043",
    x1: 23.6982,
    y1: 13.9617,
    x2: 27.2994,
    y2: 15.5287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FA9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666AD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6713_127043",
    x1: 15.0067,
    y1: 19.5852,
    x2: 18.8147,
    y2: 18.6338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A34A9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343168"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6713_127043",
    x1: 84.0158,
    y1: 77.1495,
    x2: 74.5975,
    y2: 82.8277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4497,
    stopColor: "#FE4773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6292,
    stopColor: "#FC406D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7605,
    stopColor: "#F73464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8683,
    stopColor: "#F12257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9606,
    stopColor: "#E80C46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4003D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6713_127043",
    x1: 85.7127,
    y1: 65.4794,
    x2: 81.3154,
    y2: 78.0575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4F8B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B8EAC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_6713_127043",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.4242 7.31421) rotate(0.114591) scale(39.3644)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4497,
    stopColor: "#FE4773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6292,
    stopColor: "#FC406D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7605,
    stopColor: "#F73464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8683,
    stopColor: "#F12257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9606,
    stopColor: "#E80C46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4003D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6713_127043",
    x1: 61.4577,
    y1: 35.3794,
    x2: 47.2684,
    y2: 25.1159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4003D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3434,
    stopColor: "#CD0E2D",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#972E07"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6713_127043",
    x1: 39.9231,
    y1: 28.0504,
    x2: 43.8907,
    y2: 31.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4003D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3434,
    stopColor: "#CD0E2D",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#972E07"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6713_127043",
    x1: 52.8493,
    y1: 41.3579,
    x2: 59.3902,
    y2: 50.1156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FA9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666AD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6713_127043",
    x1: 90.8614,
    y1: 38.6312,
    x2: 97.4023,
    y2: 47.3888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FA9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666AD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6713_127043",
    x1: 73.0657,
    y1: 8.26857,
    x2: 79.6064,
    y2: 17.0262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A34A9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343168"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6713_127043",
    x1: 73.2632,
    y1: 30.1126,
    x2: 78.0313,
    y2: 36.4967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4F8B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B8EAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_6713_127043",
    x1: 79.4373,
    y1: 18.3511,
    x2: 84.2053,
    y2: 24.7351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#FFDE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    stopColor: "#FFCA65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#FFAA87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF90A4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6713_127043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/confetti.9284efbc151cf8da7a78194622332682.svg";
export { ForwardRef as ReactComponent };